import styled from 'styled-components';

export const StyledBanner = styled.div<{
  minWidth: string;
  maxWidth: string;
  mx: string;
}>`
  max-width: ${({ maxWidth }) => maxWidth};
  min-width: ${({ minWidth }) => minWidth};
  margin: 0 ${({ mx }) => mx} 12px;
  border-radius: 7px;

  @media (max-width: $tablet) {
    max-width: 606px;
  }

  img {
    max-width: 100%;
    border-radius: 7px;
  }
`;
